import React, { BaseSyntheticEvent, useEffect, useRef, useState } from "react";
import * as styles from "./DesktopNav.module.css";
import * as navStyles from "./NavSearch.module.css";
import { navigate } from "gatsby";
import { useForm } from "react-hook-form";
import { NavigationItem } from "../../../types";
import { Link } from "../../elements/Link/Link";

interface Props {
  navigation: NavigationItem[];
  secondaryNavigation: NavigationItem[];
  setLoginOpen: Function;
}
interface FormValues {
  searchText: string;
}

export const defaultSearchFormValues = {
  searchText: "",
};

export const handleSearchFormSubmit = (
  data: FormValues,
  e?: BaseSyntheticEvent<object, any, any> | undefined
): void => {
  if (window && window.location.pathname.includes("/search")) {
    window.location.assign(`/search?q=${encodeURI(data.searchText)}`);
  } else {
    navigate(`/search?q=${encodeURI(data.searchText)}`);
  }
};

export const handleSearchFormError = (
  errors: {},
  e?: BaseSyntheticEvent<object, any, any> | undefined
): void => {
  console.log("Error", errors, e);
};

export const DesktopNav: React.FC<Props> = ({
  navigation,
  secondaryNavigation,
  setLoginOpen,
}) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues: defaultSearchFormValues });

  const timerRef = useRef<any>(null);
  const defaultActivePrimary = navigation?.find((item) => item.active);
  const [activePrimary, setActivePrimary] = useState<string | null | undefined>(
    defaultActivePrimary?.title || null
  );
  const [activeSecondary, setActiveSecondary] = useState<
    string | null | undefined
  >("");

  const handlePrimaryEnter = (event: MouseEvent) => {
    setActivePrimary((event.target as HTMLElement)?.textContent);
    setActiveSecondary("");
  };

  const handleSecondaryEnter = (event: MouseEvent) => {
    setActiveSecondary((event.target as HTMLElement)?.textContent);
  };

  const handleNavLeave = (event: React.MouseEvent<HTMLElement>) => {
    timerRef.current = setTimeout(() => {
      setActivePrimary(defaultActivePrimary?.title);
      setActiveSecondary("");
    }, 1000);
  };

  const handleNavEnter = (event: React.MouseEvent<HTMLElement>) => {
    clearTimeout(timerRef.current);
  };

  const handlePrimaryButtonToggle = (event: React.MouseEvent<HTMLElement>) => {
    setActivePrimary((event.target as HTMLElement)?.dataset.name);
  };

  const handleSecondaryButtonToggle = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setActiveSecondary((event.target as HTMLElement)?.dataset.name);
  };

  const handleClickLogin = (event: MouseEvent) => {
    setLoginOpen(true);
  };

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  });

  return (
    <>
      <nav
        className={styles.nav}
        aria-label="primary"
        onMouseLeave={handleNavLeave}
        onMouseEnter={handleNavEnter}
      >
        <ul className={styles.mainNavList}>
          {navigation?.map((item, idxp) => {
            return (
              <li key={`primary${idxp}`}>
                <Link
                  className={styles.mainNavItem}
                  aria-expanded={item.title === activePrimary}
                  to={item.link.href}
                  onMouseEnter={handlePrimaryEnter}
                >
                  {item.title}
                </Link>
                <button
                  className="vis-hidden"
                  onClick={handlePrimaryButtonToggle}
                  aria-expanded={item.title === activePrimary}
                  data-name={item.title}
                >
                  show submenu for {item.title}
                </button>
                {item.subnavigation && (
                  <ul className={styles.subNavList}>
                    {item.subnavigation?.map((secondaryItem, idxs) => {
                      return (
                        <li key={`secondary${idxs}`}>
                          <Link
                            className={styles.secondaryNavItem}
                            to={secondaryItem.link.href}
                            onMouseEnter={handleSecondaryEnter}
                            aria-expanded={
                              secondaryItem.title === activeSecondary
                            }
                          >
                            {secondaryItem.title}
                          </Link>
                          {secondaryItem.subnavigation && (
                            <>
                              <button
                                className="vis-hidden"
                                onClick={handleSecondaryButtonToggle}
                                aria-expanded={
                                  secondaryItem.title === activeSecondary
                                }
                                data-name={secondaryItem.title}
                              >
                                show submenu for {secondaryItem.title}
                              </button>
                              <ul className={styles.tertiaryNavList}>
                                {secondaryItem.subnavigation?.map(
                                  (tertiaryItem, idxt) => {
                                    return (
                                      <li key={`tertiary${idxt}`}>
                                        <Link
                                          className={styles.tertiaryNavItem}
                                          to={tertiaryItem.link.href}
                                        >
                                          {tertiaryItem.title}
                                        </Link>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
      <div className={styles.secondaryNavContainer}>
        <nav className={styles.secondaryNav} aria-label="secondary">
          <ul className={styles.secondaryNavList}>
            {secondaryNavigation?.map((item, i) => {
              return (
                <li key={`secondaryNav${i}`}>
                  <Link to={item.link.href}>{item.title}</Link>
                </li>
              );
            })}
            <li>
              <button
                type="button"
                className={styles.loginBtn}
                onClick={handleClickLogin}
              >
                Login
              </button>
            </li>
          </ul>
        </nav>
        <form
          className={navStyles.searchContainer}
          onSubmit={handleSubmit(handleSearchFormSubmit, handleSearchFormError)}
        >
          <input type="text" {...register("searchText")} placeholder="SEARCH" />
          <button type="submit" aria-label="search">
            <img
              src="/images/search.svg"
              alt="Magnifying glass icon for search"
            />
          </button>
        </form>
        <div className={styles.routing}>Routing Number: 101100579</div>
      </div>
    </>
  );
};
